<div class="row-center">
  <button
    irxBotonIcono tooltip="Descargar"
    [matMenuTriggerFor]="menu"
    (menuOpened)="onMenuAbierto(true)"
    (menuClosed)="onMenuAbierto(false)"
    [matBadge]="descargasPendientes ? descargasPendientes : null"
    matBadgePosition="above after"
    [matBadgeColor]="hayDescargasNuevas ? 'accent' : 'primary'"
    [activo]="hayDescargasNuevas"
    aria-hidden="false"
    data-descargas-anchor
  >
    <mat-icon>download</mat-icon>
  </button>
</div>

<mat-menu
  #menu="matMenu"
  xPosition="after"
  class="tabla-menu tabla-menu-flush"
>
  <app-listado-descargas></app-listado-descargas>
</mat-menu>
